import { render, staticRenderFns } from "./CourseCreateEditModal.vue?vue&type=template&id=af36fa04&"
import script from "./CourseCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./CourseCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports